import { IconCircleCheck, IconCircleDashed } from '@tabler/icons-react'

import { AstraCircularProgress, AstraIcon, SizeOptions } from '~/astra'

import { ProgressStatus } from './shared/utils'

type Props = {
    status: ProgressStatus
    size?: SizeOptions
    progress?: number
}

const iconByStatus = {
    future: IconCircleDashed,
    completed: IconCircleCheck,
} as const

const colorByStatusStyles = {
    future: 'text-muted',
    completed: 'text-success-emphasis',
} as const

export function PeriodStatusIcon({ status, size, progress = 50 }: Props) {
    if (status === 'current') {
        return <AstraCircularProgress value={progress} hideLabel size={14} circleColor="stroke-chart-qualitative-01-primary" />
    }
    return <AstraIcon icon={iconByStatus[status]} color={colorByStatusStyles[status]} size={size} />
}
